import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MAutocomplete from '@mui/material/Autocomplete';

const Autocomplete = (props) => {
  return (
    <MAutocomplete
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant="outlined"
        />
      )}
      {...props}
      onChange={(event, values) => props.onChange(values)}
    />
  );
};

Autocomplete.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(Autocomplete);
